import { NodeModel, NodeType, Node } from './hsbcad-model';
import { ProjectLoader } from './project-loader.service';
import { NodeLoaderService } from './node-loader.service';
import { HsbProject, DataStoreType } from './hsb-project';
import { IShareData } from './isharedata';
import { ObjectIDataDefinitionParserService } from './object-idata-definition-parser.service';
import { IProjectDB, NodeDataStorage } from './iproject-db';

export class HsbProjectsLoader {

    _baseurl: string = '';
    _access_token: string = '';
    _searchdatamodel: any = null;
    _hsbProjects: {[key:string]: HsbProject} = {};
    _reportsext: any = null;
    projectsDBs: Array<IProjectDB> = [];
    hasVisuals: boolean = true;

    constructor(public _modelmaploader: ProjectLoader,
        public _nodeloader: NodeLoaderService,
        public objectParserService: ObjectIDataDefinitionParserService) {
    }

    initialize(baseurl: string, access_token: string) {
        this._baseurl = baseurl;
        this._access_token = access_token;
        this._searchdatamodel = [];
        this._hsbProjects = {};
        this.setProjectSearchPattern('.modelnode;.node;.root;.configuration');
    }

    setProjectSearchPattern(searchpattern: string) {
        var _self = this;

        if (!searchpattern) { return; }

        _self._searchdatamodel = [];
        var splitpattern = searchpattern.split(';');

        if (splitpattern.length > 0) {

            _self._searchdatamodel = splitpattern.map(function (e) { return { nodetype: e }; });
        }
    };

    findProjectDBFromName(projectName: String) {

        let searchResult = this.projectsDBs.filter((projectDB: IProjectDB) => {

            return projectDB.name &&
                projectDB.name.toLowerCase().indexOf(projectName.toLowerCase()) >= 0;
        });

        return searchResult;
    }

    findProjectDBFromID(projectID: String) {

        let searchResult = this.projectsDBs.filter((projectDB: IProjectDB) => {

            return projectDB.projectID === projectID;
        })[0];

        return searchResult;
    }
    findProjectDBFromExternalRef(externalRef: String) {
        let searchResult = this.projectsDBs.filter((projectDB: IProjectDB) => {
            return (projectDB.nodeModel && projectDB.nodeModel.externalRef === externalRef);
        })[0];

        return searchResult;
    }

    loadProjects(projectIDs: string | string[], includeGeometry: boolean): Promise<{[key:string]:HsbProject}> {
        var _self = this;
        _self._hsbProjects = {};

        if (includeGeometry) {
            _self.setProjectSearchPattern('.modelnode;.node;.root;.configuration;.hsbsharemodel;');
        }

        return new Promise(function (resolve, reject) {

            let projectFolders: any[] = [];
            let projectDBIds: string[] = [];

            if (!Array.isArray(projectIDs)) {
                projectDBIds = [projectIDs];
            } else {
                projectDBIds = projectIDs.map(function (e) { return e; });
            }

            // Try and load from Monogo first - it this fails - load from EFS
            _self._nodeloader.loadProjectsDataDB(_self._access_token, projectDBIds, _self._searchdatamodel).then(function (dataDB) {

                let allData: any[] = [];

                let efsFolders: any[] = [];

                // Get a list of projectIDs that haven't been found in MongoDB.
                projectDBIds.forEach((filePath) => {

                    let found = dataDB.filter((data) => {
                        return data.path === filePath;
                    })[0];

                    if (found) {
                        let projectDB = _self.findProjectDBFromID(found.path);
                        if (!projectDB) {
                            return reject("HsbProjectsLoader.loadProjects(): No project found in the databse for given path!");
                        }
                        if (projectDB.nodeDataStorage !== NodeDataStorage.MongoDB && found.data === 0) {
                            efsFolders.push('/projects/' + found.path);
                        } else {
                            allData.push(found);
                        }
                    }
                });

                _self._nodeloader.loadProjectsData(_self._access_token, efsFolders, _self._searchdatamodel).then(function (data) {
                    allData = allData.concat(data);

                    _self.loadAllData(allData, includeGeometry).then(function (data) {
                        // _self.loadProjectModelThumbnailDataURLs(_self._hsbProjects[Object.keys(_self._hsbProjects)[0]]).then(dataURL => {
                        //     return resolve(_self._hsbProjects);
                        // }).catch(function (err) {
                        //     return reject(err);
                        // });
                        resolve(_self._hsbProjects)
                    }).catch(function (err) {
                        return reject(err);
                    });
                }).catch(function (err) {
                    return reject(err);
                });
            }).catch(function (err) {
                _self._nodeloader.loadProjectsData(_self._access_token, projectFolders, _self._searchdatamodel).then(function (data) {
                    _self.loadAllData(data, includeGeometry).then(function (data) {
                        _self.loadProjectModelThumbnailDataURLs(_self._hsbProjects[Object.keys(_self._hsbProjects)[0]]).then(dataURL => {
                            return resolve(_self._hsbProjects);
                        }).catch(function (err) {
                            return reject(err);
                        });
                    }).catch(function (err) {
                        return reject(err);
                    });
                }).catch(function (err) {
                    return reject(err);
                });
            });
        });
    };

    loadAllData(projectNodeArray: any[], includeGeometry: boolean) {

        let _self = this;

        return new Promise(function (resolve, reject) {

            projectNodeArray.forEach(function (findFilesObj) {

                let dataStore = findFilesObj.dataStore;
                var hsbProject = _self.createHsbProject(findFilesObj.path, dataStore);
                let projectDB = _self.findProjectDBFromID(hsbProject.projectID);

                if (!projectDB) {
                    return reject("failed to load project");
                }

                if (projectDB.nodeDataStorage && projectDB.nodeDataStorage === NodeDataStorage.MongoDB) {
                    hsbProject.NodeStorage = DataStoreType.Database;
                } else {
                    hsbProject.NodeStorage = dataStore;
                }

                // If projectDB is a DB project then force to DB.
                _self._nodeloader.createModel(findFilesObj.data, hsbProject.nodeModel, findFilesObj.path);
                _self._hsbProjects[hsbProject.projectID] = hsbProject;
            });

            if (includeGeometry && projectNodeArray.length === 1) {
                _self.loadGeometry().then(function (data) {

                    let hsbproject = _self._hsbProjects[Object.keys(_self._hsbProjects)[0]];

                    if (hsbproject && Object.keys(hsbproject.HsbModels).length === 0) {
                        // No models, just advise user no models attached to this project.
                        _self.hasVisuals = false;
                    } else {
                        _self.hasVisuals = true;
                    }

                    if (hsbproject.NodeStorage === DataStoreType.EFS) {
                        _self.loadAllDocuments();
                    }
                    return resolve(_self._hsbProjects);
                }).catch(function (err) {
                         reject(err);
                });
            } else {
                resolve(_self._hsbProjects);
            }
        });
    }



    migrateProject(hsbProject: any) {
        let self = this;

        return new Promise(function (resolve, reject) {

            if (hsbProject.NodeStorage === DataStoreType.EFS) {

                self._nodeloader.migrateUptoDB(hsbProject).then(function (data) {

                    self._nodeloader.setNodeDataStorage(hsbProject.projectID, NodeDataStorage.MongoDB).then(function (projectUpdate: any) {

                        let projectDB = self.findProjectDBFromID(hsbProject.projectID);

                        if (projectDB) {
                            projectDB.nodeDataStorage = projectUpdate.nodeDataStorage;
                        }
                        resolve('success');
                    });

                }, function (error) { return reject(error); });

            } else {
                self._nodeloader.migrateDownToEFS(hsbProject).then(function (data) {

                    self._nodeloader.setNodeDataStorage(hsbProject.projectID, NodeDataStorage.EFS).then(function (projectUpdate: any) {

                        let projectDB = self.findProjectDBFromID(hsbProject.projectID);

                        if (projectDB) {
                            projectDB.nodeDataStorage = projectUpdate.nodeDataStorage;
                        }
                        resolve('success');
                    });

                }, function (error) { return reject(error); });

            }
        });
    }

    // Method to reload the Items data, that is the all the modelnode for widgets refresh
    reLoadProject(hsbProject: HsbProject) {
        var self = this;

        // We need to just pull the modelnodes from the server for this project - No geometry data as this has already been loaded.
        return new Promise(function (resolve, reject) {

            var projectFolders = {};

            self.setProjectSearchPattern('.modelnode');

            projectFolders = ['/projects/' + hsbProject.projectID];

            self._nodeloader.loadProjectsData(self._access_token, projectFolders, self._searchdatamodel).then(function (data) {

                data.forEach(function (findFilesObj) {

                    if (hsbProject.nodeModel && hsbProject.nodeModel.ItemsRoot) {
                        //self._nodeloader.createModel(findFilesObj.data, hsbProject.nodeModel, findFilesObj.path);
                    }
                });
            });
        });
    }

    loadAllDocuments() {

        var _self = this;

        Object.keys(_self._hsbProjects).forEach(function (key) {
            var hsbProject = _self._hsbProjects[key];

            _self._nodeloader.loadAllDocs(hsbProject).then(function () {

                _self._modelmaploader.createDocNodeList(hsbProject);
            });
        });
    }

    loadGeometry() {
        var _self = this;

        var promisefunctions: Promise<any>[] = [];
        Object.keys(_self._hsbProjects).forEach(function (key) {
            var hsbProject = _self._hsbProjects[key];
            let hsbMakeModels = hsbProject.nodeModel.getNodesMetadataIdByItemType(hsbProject.nodeModel.ItemsRoot, 'hsbshare.projectmodel');

            if (hsbMakeModels && hsbMakeModels.length === 0) {
                hsbMakeModels = hsbProject.nodeModel.getNodesMetadataIdByNodeType(hsbProject.nodeModel.ItemsRoot, NodeType.HsbModel);

                hsbMakeModels.forEach((model: any) => {
                    // Create a properties entry.
                    model.metadata.data.properties = {};

                    if (!model.metadata.data.modelId) {
                        model.metadata.data.modelId = model.metadata.data.modelname;
                    }

                    model.metadata.data.properties["modelName"] = { value: model.metadata.data.modelname, type: 'string' };
                    model.metadata.data.properties["modelId"] = { value: model.metadata.data.modelId, type: 'string' };
                    model.metadata.data.properties["setName"] = { value: model.metadata.data.setname, type: 'string' };
                    model.metadata.data.properties["active"] = { value: model.metadata.data.active, type: 'boolean' };
                });
            }

            var promise;
            if (hsbMakeModels.length > 0) {

                promise = new Promise(function (resolve, reject) {

                    _self._modelmaploader.loadGeometryData(hsbMakeModels, hsbProject).then(function (data) {

                        resolve('success');
                    }, function (error) { return reject(error); });

                });
                promisefunctions.push(promise);
            } else {

                promisefunctions.push(Promise.resolve('success'));
            }
        });

        return Promise.all(promisefunctions);
    };

    loadBuffersForModel(hsbProject: HsbProject, hsbModel: any) {
        let self = this;

        return new Promise(function (resolve, reject) {

            if (hsbProject.NodeStorage === DataStoreType.EFS) {
                console.error('Please no EFS');
            } else {
                self.loadBuffersForModelDB(hsbProject, hsbModel).then(function (data) {

                    resolve('success');
                }, function (error) { return reject(error); });

            }
        });
    }


    loadBuffersForModelDB(hsbProject: HsbProject, hsbModel: any) {
        let _self = this;
        hsbProject.geomBuffersCount = 0;
        return new Promise(function (resolve, reject) {

            if (hsbModel.geomBuffers && hsbModel.geomBuffers.length > 0) {
                resolve('success');
            } else {

                if (!hsbModel.Node) {
                    return reject('No Project Mode DB node found');
                }

                if (!hsbModel.Node.metadata.data.properties || !hsbModel.Node.metadata.data.properties['modelId']) {
                    return reject('No molelId found in properties');
                }
                let modelId = hsbModel.Node.metadata.data.properties['modelId'].value;

                let hsbFiles = hsbModel.Node.metadata.data.documents.filter((doc) => {

                    let fileName = doc.path.split("/").pop();
                    return (fileName.indexOf('.hsb') !== -1)
                });

                if (hsbFiles.length === 0) {
                    return reject('No Model Geometry Files in EFS');
                }

                hsbModel.geomBuffers = [];
                hsbModel.geomBuffersCount = hsbFiles.length;
                hsbProject.geomBuffersCount += hsbModel.geomBuffersCount;
                // IFC models are always using 'mm' for their units. Even if they have 'm' set as their unit the model data is actually in 'mm'.
                // HMLX models are exported without any dependence on their units. 
                // eg.: 
                // IFC: A wall is 10 units long and the unit is set to 'm'. The geometry data will convert the wall to be 10000 units long and set the model unit to be 'm'.
                // HMLX: If a wall is 10 units and the user sets the project unit to 'm'. The geometry data will have that wall as 10 units and set the model unit to be 'm'.
                // 
                var unitFactor = (hsbProject.projectSource !== 'ifc') ? hsbModel.Units.factor : 1;

                var promisefunctions: Promise<any>[] = [];

                hsbFiles.forEach((file)=> {

                    // eslint-disable-next-line no-loop-func
                    var promise = new Promise(function (resolve, reject) {

                        _self._nodeloader.getFile(file.path).then(function (metadata: any) {

                            // Now build the model from this file data
                            if (metadata?.data) {
                                var geomBuffer: any = { modelId: modelId, filepath: metadata.filepath, data: metadata.data };
                                // Set according to unitfactor
                                if (unitFactor !== 1) {
                                    Object.values(geomBuffer.data).forEach((value: any) => {
                                        if (value.buffer)
                                            value.buffer = value.buffer.map((v) => v * unitFactor);
                                    })
                                }
                                hsbModel.geomBuffers.push(geomBuffer);
                            }
                            resolve({ message: 'succes', data: { path: file.path, buffer: geomBuffer } });
                        }).catch(function (err) {
                            reject({ message: 'Something went wring while fetching the file at ' + file.path, error: err });
                        });
                    });
                    promisefunctions.push(promise);
                });

                Promise.all(promisefunctions).then(function (data) {
                    resolve(data)
                }).catch(function (err) {
                    reject(err);
                });
            }
        });
    }

    //entry point
    loadGeometryBuffers(hsbProject) {
        let _self = this;

        return new Promise(function (resolve, reject) {

            var numModels = Object.keys(hsbProject.HsbModels).length;
            var modelCount = 0;

            if (numModels === 0) {
                return resolve('success');
            }

            for (var modelkey in hsbProject.HsbModels) {

                var hsbModel = hsbProject.HsbModels[modelkey];

                // eslint-disable-next-line no-loop-func
                _self.loadBuffersForModel(hsbProject, hsbModel).then(function (data) {
                    modelCount++;
                    if (numModels === modelCount) {
                        _self._modelmaploader.removeEmptyGroupNodes(hsbProject);
                        resolve('success');
                    }

                }).catch(function (err) {
                    reject(err);
                });
            }
        });
    }

    getNodes(nodetype) {
        var _self = this;

        var allfoundnodes: Node[] = [];

        Object.keys(_self._hsbProjects).forEach(function (key) {

            var nodemodel = _self._hsbProjects[key].nodeModel;

            if (nodemodel) {
                var foundnodes = nodemodel.getNodesMetadataIdByItemType(nodemodel.ItemsRoot, nodetype);
                allfoundnodes = allfoundnodes.concat(foundnodes);
            }
        });

        return allfoundnodes;
    };

    getNodesMetadataIdByItemType(itemtype, nodetype) {
        var _self = this;

        var allfoundnodes: Node[] = [];

        Object.keys(_self._hsbProjects).forEach(function (key) {

            var nodemodel = _self._hsbProjects[key].nodeModel;

            if (nodemodel) {
                var foundnodes = nodemodel.getNodesMetadataIdByItemType(nodemodel.ItemsRoot, nodetype);
                allfoundnodes = allfoundnodes.concat(foundnodes);
            }
        });

        return allfoundnodes;
    };
    createHsbProject(datastoreFolder, dataStore: DataStoreType) {
        var _self = this;

        var hsbProject = new HsbProject(_self._baseurl);

        if (dataStore === DataStoreType.EFS) {
            hsbProject.projectID = datastoreFolder.replace('/projects/', '');
            hsbProject.datastoreFolder = datastoreFolder;
        } else {
            hsbProject.projectID = datastoreFolder;
            hsbProject.datastoreFolder = '/projectData/' + hsbProject.projectID;
        }

        hsbProject.nodeModel = _self.createNodeModel(hsbProject);

        return hsbProject;
    };

    createNodeModel(hsbProject) {

        var nodeModel = new NodeModel("root", "root", hsbProject);
        var rootnode = nodeModel.root;

        // Create main data and config node - these will be the main root node of the trees
        var node = nodeModel.createNode("data", rootnode);
        nodeModel.addChildNode(rootnode, node);

        // Create config node of data.
        node = nodeModel.createNode("config", rootnode);
        nodeModel.addChildNode(rootnode, node);

        var dataroot = nodeModel.findGroupChildNode(nodeModel.root, "data");

        if (dataroot) {

            // Create model root nodes.
            var datamodelroot = nodeModel.createNode(NodeType.Items, dataroot);
            nodeModel.ItemsRoot = datamodelroot;
            datamodelroot.metadata.data = { origin: "datastore", itemtype: NodeType.Items };
            nodeModel.addChildNode(dataroot, datamodelroot);

            datamodelroot = nodeModel.createNode(NodeType.Model, dataroot);
            datamodelroot.metadata.data = { origin: "datastore", itemtype: NodeType.Model };
            nodeModel.ModelRoot = datamodelroot;
            nodeModel.addChildNode(dataroot, datamodelroot);
        }

        return nodeModel;
    };
    deleteNode(shareData: IShareData) {
        var self = this;

        return new Promise(function (resolve, reject) {
            if (!shareData.data) return

            self._nodeloader.deleteItemData(shareData.hsbProject.nodeModel, shareData.modelNode).then(function (returndata) {
                resolve({ status: 204 });
            }).catch(error => {
                console.error('Error deleting node (node loader): ' + error);
            });
        }).catch(error => {
            console.error('Error deleting node: ' + error);
        });
    };

    updateNodeProperties(node, jsonData) {

        return new Promise(function (resolve, reject) {

            if (!node || !jsonData) {
                reject({ success: false, Message: 'Invalid Input Data' });
            }
            if (node.metadata.data && !node.metadata.data.properties) {
                reject({ success: false, Message: 'No Node Properties' });
            }

            var properties = node.metadata.data.properties;

            // Set properties from the input json
            Object.keys(jsonData).forEach(function (key) {

                if (key !== '_node') {
                    var searchResult = properties.filter(function (property) {
                        return (property.data.key === key);
                    });

                    if (searchResult.length > 0) {
                        searchResult[0].data.value = jsonData[key];
                    }
                }
            });

            resolve(node);
        });
    };
    createNode(projectID, nodename, itemtype) {
        var _self = this;

        var promise = new Promise(function (resolve, reject) {

            if (!projectID || !nodename || !itemtype) {
                reject({ success: false, Message: 'Invalid Data' })
            }

            // Find the model from the path ID
            var nodeModel = _self.findNodeModel(projectID);

            if (nodeModel === undefined) {
                reject({ success: false, Message: 'Invalid NodeModel' });
                return;
            }

            //Get all the root node of the item type to get the root pathid.
            var rootnode = nodeModel.getNodesMetadataIdByItemType(nodeModel.root, NodeType.Root)[0];
            var confignodedata = nodeModel.getnodedefault(NodeType.Item, itemtype);

            if (!rootnode || !confignodedata) {
                reject({ success: false, Message: 'Invalid Rootnode or confignodedata' });
            }

            // Create new instance.
            var metadata: any = { data: confignodedata };
            var node: any = { metadata: metadata };
            node.metadata.fileinfo = { path: rootnode.pathid + "/" + nodename.trim() + "/.node", read_only: false };
            node.pathid = rootnode.pathid + "/" + nodename.trim();

            resolve(node);
        });

        return promise;
    };

    insertNode(shareData: IShareData) {
        var self = this;

        return new Promise(function (resolve, reject) {
            if (!shareData.data) return

            let dataDefinition = self.objectParserService.getIDataDefinition(shareData.data.toObject());

            self._nodeloader.updateModelNode(dataDefinition, shareData).then(function (returndata) {
                resolve({ status: 201, data: returndata });
            }).catch(error => {
                console.error('Error inserting node (database): ' + error);
                reject({ error: error, message: "Error while trying to update model node" })
            });
        }).catch(error => {
            console.error('Error inserting node: ' + error);
            throw error;
        });
    };

    updateNode(shareData: IShareData) {
        var self = this;

        return new Promise(function (resolve, reject) {
            if (!shareData.data) return

            let dataDefinition = self.objectParserService.getIDataDefinition(shareData.data.toObject());

            self._nodeloader.updateModelNode(dataDefinition, shareData).then(function (returndata) {
                resolve({ status: 204 });
            }).catch(error => {
                console.error('Error inserting node (node loader): ' + error);
            });
        }).catch(error => {
            console.error('Error updating node: ' + error);
        });
    };

    findNodeModel(pathid) {
        return Object.entries(this._hsbProjects).find(([key, value]) => key.includes(pathid))?.[1]?.nodeModel;
    };
    findhsbProject(pathid) {
        var _self = this;

        var foundkey!: string;

        Object.keys(_self._hsbProjects).forEach(function (key) {

            if (!foundkey && pathid.indexOf(key) !== -1) {

                foundkey = key;
            }
        });

        return _self._hsbProjects[foundkey];
    };

    clearHsbProjects() {
        try {
            if (!this._hsbProjects)
                return;
            Object.keys(this._hsbProjects).forEach((key) => {
                if (this._hsbProjects[key])
                    delete this._hsbProjects[key];
            })
            this._hsbProjects = {};
        }
        catch (err) {
            console.error(err);
        }
    }
    clearHsbProject(projectID: string) {
        delete this._hsbProjects[projectID];
    }
    getProjectsNoGeometry(projectIds): Promise<{[key:string]:HsbProject}> {
        let self = this;
        return new Promise(function (resolve, reject) {
            self.loadProjects(projectIds, false).then(projects => {
                resolve(projects);
            }).catch(function (err) {
                return reject(err);
            });
        });
    }
    getProjectThumbnailDataURLs(projectDBs: Array<IProjectDB>) {
        let self = this;
        return new Promise(function (resolve, reject) {
            let projectIds = projectDBs.map((projectDB) => { return projectDB.projectID });

            self.getProjectsNoGeometry(projectIds).then(projects => {

                let thumbnaildataUrls = {};
                let promisefunctions:Promise<string>[] = [];

                Object.keys(projects).forEach(function (projectKey) {
                    let projectDB = projectDBs.filter(e => { return e.projectID == projectKey })[0];
                    if (!projectDB) return;
                    let thumbnail = self.getActiveModelThumbnailURL(projects[projectKey]);

                    if (thumbnail) {
                        var promise = new Promise<string>(function (resolve, reject) {
                            self._nodeloader.getFileUrl(thumbnail).then(dataURL => {
                                thumbnaildataUrls[projectKey] = dataURL;
                                resolve(dataURL);
                            }).catch(function (err) {
                                if (projectDB.nodeModel) {
                                    thumbnaildataUrls[projectKey] = projectDB.nodeModel.thumbnailDataUrl;
                                    resolve(projectDB.nodeModel.thumbnailDataUrl);
                                    
                                }
                                reject("HsbProjectsLoader.getProjectThumbnailDataURLs(): Something went wrong while fetching the file url!");
                            });

                        });
                        promisefunctions.push(promise);
                    }
                });

                Promise.all(promisefunctions).then(function (result) {
                    resolve(thumbnaildataUrls);
                }).catch(function (err) {
                    return reject(err);
                });

            }).catch(function (err) {
                return reject(err);
            });

        });
    }
    loadProjectModelThumbnailDataURLs(hsbProject: HsbProject) {
        let self = this;
        return new Promise(function (resolve, reject) {
            let promisefunctions: Promise<string>[] = [];
            let hsbMakeModels = hsbProject.nodeModel.getNodesMetadataIdByItemType(hsbProject.nodeModel.ItemsRoot, "hsbshare.projectmodel");

            hsbMakeModels.forEach((node: any) => {
                let metaData = Object.fromEntries(Object.entries(node.metadata.data.properties).map(([key, val]: [any, any]) => {
                    return [key, val.value]
                }));

                let thumbnail = self.getModelThumbnailURL(hsbProject, metaData.modelId);

                if (thumbnail) {
                    var promise = new Promise<string>(function (resolve, reject) {
                        self._nodeloader.getFileUrl(thumbnail).then(dataURL => {
                            node.thumbnailDataUrl = dataURL;
                            resolve(dataURL);
                        }).catch(function (err) {
                            node.thumbnailDataUrl = null;
                            reject('HsbProjectsLoader.loadProjectModelThumbnailDataURLs(): Something went wrong while fetching the thumbnail.' + err.message);
                        });

                    });
                    promisefunctions.push(promise);
                }
            });

            Promise.all(promisefunctions).then(function (result) {
                resolve(result);
            }).catch(function (err) {
                return reject(err);
            });

        });
    }
    private getThumbnailURL(hsbProject: HsbProject, activeModelNode: any) {
        let self = this;
        if (!activeModelNode) {
            return null;
        }
        let modelId = activeModelNode.properties['modelId'].value;
        let fileName = hsbProject.datastoreFolder + '/' + activeModelNode._id + '/' + modelId + '_thumbnail.jpg';
        return self._nodeloader._baseurl + self._nodeloader._datastoreUrl + '/getFile?path=' + fileName + '&access_token=' + self._nodeloader._credentials.token;
    }
    getActiveModelThumbnailURL(hsbProject: HsbProject) {

        let activeModelNode = hsbProject.getProjectModelNode();
        if (!activeModelNode) return null;
        return this.getThumbnailURL(hsbProject, activeModelNode);
    }
    getModelThumbnailURL(hsbProject: HsbProject, modelId: string) {

        let activeModelNode = hsbProject.getProjectModelNode(modelId);
        if (!activeModelNode) return null;
        return this.getThumbnailURL(hsbProject, activeModelNode);
    }

}
